
import XInput from 'vux/src/components/x-input/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'


export default {
components: {
XInput,
XAddress
},
props: {},
data() {
return {
name: "",
tel: "",
address: [],
id: this.$route.params.id,
addressData: ChinaAddressV4Data,
detailsAdd: "",
prizeData: [
"http://cdn.qianhai12315.com/m8/static/img/jp1.png",
"http://cdn.qianhai12315.com/m8/static/img/jp2.png",
"http://cdn.qianhai12315.com/m8/static/img/jp3.png",

],
level: this.$route.params.level,
};
},
watch: {

},
computed: {

},
methods: {

onShadowChange(ids, names) {
this.addressK = names[0] + names[1] + names[2];
},
submitTap() {
if (!this.validations.empty(this.name)) {
this.$vux.toast.show({
text: "请填写姓名",
time: "2000",
width: "4rem",
position: "middle",
type: "text"
});
} else if (!this.validations.empty(this.tel)) {
this.$vux.toast.show({
text: "请填写电话",
time: "2000",
width: "4rem",
position: "middle",
type: "text"
});
} else if (!this.validations.telCheck(this.tel)) {
this.$vux.toast.show({
text: "请填写正确手机号码",
time: "2000",
width: "4rem",
position: "middle",
type: "text"
});
} else if (!this.validations.empty(this.address)) {
this.$vux.toast.show({
text: "请填写地址",
time: "2000",
width: "4rem",
position: "middle",
type: "text"
});
} else if (!this.validations.empty(this.detailsAdd)) {
this.$vux.toast.show({
text: "请填写详细地址",
time: "2000",
width: "4rem",
position: "middle",
type: "text"
});
} else {
console.log("验证通过");
let data = {
openid: this.local.openid,
prize_id: this.id,
honoree: this.name,
phone_num: this.tel,
address: this.addressK + this.detailsAdd
};
this.getPrize(data);
}
},
getPrize(data) {
this.request(
"/prize/get_prize",
data,
"POST",
"application/x-www-form-urlencoded"
)
.then(res => {
console.log(res);
if (res.data.ret == 200) {
console.log("填写信息成功");
this.$vux.toast.show({
text: "提交成功",
time: "2000",
width: "2.5rem",
position: "middle",
type: "success"
});
} else {
this.$vux.toast.show({
text: res.data.error,
time: "2000",
width: "5rem",
position: "middle",
type: "text"
});
}
})
.catch(err => {
console.log(err);
this.$vux.toast.show({
text: err,
time: "2000",
width: "5rem",
position: "middle",
type: "text"
});
});
}
},
created() {

},
mounted() {
















}
};



// WEBPACK FOOTER //
// ./src/pages/data.vue